import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { ThemeProvider } from "@mui/material";
import { useAuth } from "./AuthContext.jsx";
import { applyBranding, getAppliedBrandingKey, theme as currentTheme } from "../../theme/theme.js";
import { brandingKey } from "../../theme/brandPalette.js";

/**
 * Aplica los colores de marca blanca de la agencia del usuario.
 * Al cambiar la marca se vuelve a montar el árbol para que los componentes que
 * leen `brand`/`colors` de forma estática tomen los valores nuevos.
 */
export const BrandingProvider = ({ children }) => {
  const { user, isLoading } = useAuth();
  const branding = user?.agencyBranding || null;
  // Mientras se restaura la sesión se mantiene la marca aplicada desde la caché
  const key = isLoading ? getAppliedBrandingKey() : brandingKey(branding);

  const theme = useMemo(
    () => (key === getAppliedBrandingKey() ? currentTheme : applyBranding(branding)),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [key]
  );

  return (
    <ThemeProvider theme={theme}>
      <React.Fragment key={key}>{children}</React.Fragment>
    </ThemeProvider>
  );
};

BrandingProvider.propTypes = {
  children: PropTypes.node,
};
